import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemAms} from '../AM/FormChooseAm.jsx'
import Model from './ModelAmar.mjs'

export const FormItemArName = props => (
    <FormItemBizProp
        Model={Model}
        prop="arName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemArNo = props => (
    <FormItemBizProp
        Model={Model}
        prop="arNo"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseAmar(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemAms />
            <FormItemArNo />
            <FormItemArName />
        </FormChooseDesign>
    )
}
